module.exports = __webpack_public_path__ + "static/email/img/icon_edit.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_edit.png
// module id = U6G2
// module chunks = 1